import { FieldProps } from "@/app/types"
import useLocaleStore from "@/app/stores/useLocaleStore"
import { Dropdown } from "../Dropdown"

interface Props extends FieldProps {
  value: { id: string; name: string }
  onChange: (value: { id: string; name: string }) => void
}

export const RoomsDropdown = ({ className, label, value, onChange }: Props) => {
  const locale = useLocaleStore((state) => state.locale)
  const rooms = [
    { id: "", name: locale === "en" ? "All" : "ሁሉም" },
    { id: "1", name: "1" },
    { id: "2", name: "2" },
    { id: "3", name: "3" },
    { id: "4", name: "4+" }
  ]

  return <Dropdown label={label || ""} items={rooms} className={className} value={value} onChange={onChange} />
}
